class ConditionService {
    constructor() {
      
    }
 
    defaultConditions = [
      { order:"1",
        _id: "",
        monsterId: "",
        name: "Blinded",
        description: "",
        icon: "",
      },

      {
        order:"2",
        _id: "",
        monsterId: "",
        name: "Burning",
        description: "",
        icon: "",
      },

      {
        order:"3",
        _id: "",
        monsterId: "",
        name: "Concentration",
        description: "",
        icon: "",
      },

      {
        order:"4",
        _id: "",
        monsterId: "",
        name: "Charmed",
        description: "",
        icon: "",
      },

      {
        order:"5",
        _id: "",
        monsterId: "",
        name: "Deafened",
        description: "",
        icon: "",
      },
      {
        order:"6",
        _id: "",
        monsterId: "",
        name: "Exhaustion",
        description: "",
        icon: "",
      },
      {
        order:"7",
        _id: "",
        monsterId: "",
        name: "Frightened",
        description: "",
        icon: "",
      },
      {
        order:"8",
        _id: "",
        monsterId: "",
        name: "Grappled",
        description: "",
        icon: "",
      },
      {
        order:"9",
        _id: "",
        monsterId: "",
        name: "Incapacitated",
        description: "",
        icon: "",
      },
      {
        order:"10",
        _id: "",
        monsterId: "",
        name: "Invisible",
        description: "",
        icon: "",
      },
      {
        order:"11",
        _id: "",
        monsterId: "",
        name: "Paralyzed",
        description: "",
        icon: "",
      },
      {
        order:"12",
        _id: "",
        monsterId: "",
        name: "Petrified",
        description: "",
        icon: "",
      },
      {
        order:"13",
        _id: "",
        monsterId: "",
        name: "Poisoned",
        description: "",
        icon: "",
      },
      {
        order:"14",
        _id: "",
        monsterId: "",
        name: "Prone",
        description: "",
        icon: "",
      },
      {
        order:"15",
        _id: "",
        monsterId: "",
        name: "Restrained",
        description: "",
        icon: "",
      },
      {order:"16",
        _id: "",
        monsterId: "",
        name: "Stunned",
        description: "",
        icon: "",
      },

      {order:"17",
        _id: "",
        monsterId: "",
        name: "Unconcious",
        description: "",
        icon: "",
      },

      {order:"999",
        _id: "",
        monsterId: "",
        name: "Dead",
        description: "",
        icon: "",
      },

      
    ]

        getConditions(){
          return this.defaultConditions;
        };

   
      };
  
  export default new ConditionService();